import React, { useEffect, useState } from "react";
import HomeMain from "./HomeMain";
import Header from "../../components/site/Header";
import Footer from "../../components/site/Footer";
import BackToTop from "../../components/elements/BackToTop";

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    setIsVisible(y > 300);
  };

  useEffect(() => {
    handleScroll(); // وضعیت اولیه
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Header />
      <main>
        <HomeMain />
      </main>
      <BackToTop scroll={isVisible} />
      <Footer />
    </>
  );
};

export default Home;
